<template>
  <div v-if="activeVenue">
    <h3>Activation Plan</h3>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        icon-pack="feather"
        icon="icon-activity"
        :label="!isSmallerScreen ? activeVenue.name : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <activation-plan-venue />
        </div>
      </vs-tab>
      <vs-tab
        v-if="
          $AuthService.hasPermissionForActiveVenue(
            'vp.vp.activationplan.hqcampaigns'
          )
        "
        icon-pack="feather"
        icon="icon-briefcase"
        :label="!isSmallerScreen ? 'HQ Campaigns' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <activation-plan-hq-campaigns />
        </div>
      </vs-tab>
      <vs-tab
        v-if="
          $AuthService.hasPermissionForActiveVenue(
            'vp.vp.activationplan.overview'
          )
        "
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Overview' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <activation-plan-overview />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import ActivationPlanVenue from "./ActivationPlanVenue.vue";
import ActivationPlanOverview from "./ActivationPlanOverview.vue";
import ActivationPlanHqCampaigns from "./ActivationPlanHqCampaigns.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ActivationPlanVenue,
    ActivationPlanOverview,
    ActivationPlanHqCampaigns,
  },
  data() {
    return {};
  },
  async mounted() {
    //await this.$store.dispatch("venues/ensureUserVenues"); //ensureUserVenues
  },

  methods: {},
  computed: {
    ...mapGetters({
      isHQ: "users/isHQ",
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
</style>
